// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import MainLayout from './components/MainLayout';
import PoaPage from './pages/PoaPage';
import PoaForm from './pages/PoaForm';
import PoaDetail from './pages/PoaDetail';
import MetaList from './pages/MetaList';
import MetaForm from './pages/MetaForm';
import MatrizList from './pages/MatrizList';
import MatrizForm from './pages/MatrizForm';
import VinculacionList from './pages/VinculacionList';
import VinculacionForm from './pages/VinculacionForm';

// Nuevos componentes: Catálogos base
import SectorList from './pages/SectorList';
import SectorForm from './pages/SectorForm';
import ProgramaList from './pages/ProgramaList';
import ProgramaForm from './pages/ProgramaForm';
import ProyectoList from './pages/ProyectoList';
import ProyectoForm from './pages/ProyectoForm';
import DepartamentoList from './pages/DepartamentoList';
import DepartamentoForm from './pages/DepartamentoForm';

const App = () => {
  const isAuthenticated = !!localStorage.getItem('user');

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={isAuthenticated ? <MainLayout /> : <Navigate to="/login" />}
        >
          <Route index element={<div>Bienvenido al Sistema POA</div>} />

          {/* POA */}
          <Route path="poa" element={<PoaPage />} />
          <Route path="poa/nuevo" element={<PoaForm />} />
          <Route path="poa/:id/editar" element={<PoaForm />} />
          <Route path="poa/:id" element={<PoaDetail />} />

          {/* Metas */}
          <Route path="poa/:idPoa/metas" element={<MetaList />} />
          <Route path="poa/:idPoa/metas/nuevo" element={<MetaForm />} />
          <Route path="poa/:idPoa/metas/:idMeta" element={<MetaForm />} />

          {/* Matriz Lógica */}
          <Route path="poa/:idPoa/matriz" element={<MatrizList />} />
          <Route path="poa/:idPoa/matriz/nuevo" element={<MatrizForm />} />
          <Route path="poa/:idPoa/matriz/:idActividad" element={<MatrizForm />} />

          {/* Vinculación Presupuestaria */}
          <Route path="poa/:idPoa/matriz/:idActividad/partidas" element={<VinculacionList />} />
          <Route path="poa/:idPoa/matriz/:idActividad/partidas/nuevo" element={<VinculacionForm />} />
          <Route path="poa/:idPoa/matriz/:idActividad/partidas/:idPartida" element={<VinculacionForm />} />

          {/* Catálogos base */}
          <Route path="sectores" element={<SectorList />} />
          <Route path="sectores/nuevo" element={<SectorForm />} />
          <Route path="sectores/:id" element={<SectorForm />} />

          <Route path="programas" element={<ProgramaList />} />
          <Route path="programas/nuevo" element={<ProgramaForm />} />
          <Route path="programas/:id" element={<ProgramaForm />} />

          <Route path="proyectos" element={<ProyectoList />} />
          <Route path="proyectos/nuevo" element={<ProyectoForm />} />
          <Route path="proyectos/:id" element={<ProyectoForm />} />

          <Route path="departamentos" element={<DepartamentoList />} />
          <Route path="departamentos/nuevo" element={<DepartamentoForm />} />
          <Route path="departamentos/:id" element={<DepartamentoForm />} />

          {/* Ruta comodín al FINAL */}
          <Route path="*" element={<Navigate to="/" />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;